import {CompatibleWithModel} from "../models/view/compatibleWithModel";
import {useProductVariables} from "./useProductVariables";
import {useSuspenseQuery} from "@apollo/client";
import {contentService} from "../api/contentService";
import {CrossSellType} from "../definitions/types";

export const useCompatibleWithQuery = () => {
    const {variables} = useProductVariables();

    const {data} = useSuspenseQuery(contentService.product.compatibility, {
        errorPolicy: 'none',
        variables
    });

    return {model: new CompatibleWithModel(data?.product?.compatibleWith?.filter((compatibleProduct): compatibleProduct is CrossSellType => compatibleProduct !== null) ?? [] as CrossSellType[])};
}